import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(email, password)
      navigate('/dashboard')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleGoogleLogin = () => {
    setError('Google OAuth configuration required. Please use email login.')
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-left">
          <Link to="/" className="auth-logo">
            <div className="logo-icon"><span className="logo-t">T</span></div>
            <div className="logo-text">
              <span className="logo-title">Tredex</span>
              <span className="logo-subtitle">AI Products</span>
            </div>
          </Link>
          <div className="auth-illustration">
            <div className="auth-quote">
              <h2>Welcome Back!</h2>
              <p>Continue your AI-powered journey with your enterprise products.</p>
            </div>
            <div className="auth-features">
              <div className="auth-feature"><i className="fas fa-check-circle"></i> 6 AI Products</div>
              <div className="auth-feature"><i className="fas fa-check-circle"></i> 14-Day Free Trial</div>
              <div className="auth-feature"><i className="fas fa-check-circle"></i> No Credit Card</div>
            </div>
          </div>
        </div>
        <div className="auth-right">
          <div className="auth-form-wrapper">
            <h2>Sign In</h2>
            <p className="auth-sub">Access your TRED-EX AI dashboard</p>
            
            {error && <div className="auth-error"><i className="fas fa-exclamation-circle"></i> {error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required />
                <i className="fas fa-envelope input-icon"></i>
              </div>
              <div className="form-group">
                <label>Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required minLength={6} />
                <i className="fas fa-lock input-icon"></i>
              </div>
              <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={loading}>
                {loading ? 'Signing in...' : 'Sign In'} <i className="fas fa-arrow-right"></i>
              </button>
            </form>

            <div className="auth-divider"><span>OR</span></div>

            <button onClick={handleGoogleLogin} className="btn btn-outline btn-lg btn-block">
              <i className="fab fa-google"></i> Continue with Google
            </button>

            <div className="auth-forgot">
              <Link to="/forgot-password">Forgot password?</Link>
            </div>

            <p className="auth-footer-text">
              Don't have an account? <Link to="/signup">Sign up free</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}